import { circle as turfCircle, distance } from '@turf/turf'

// Custom MapboxDraw mode: click to set the center, move the mouse to size the
// circle, click again (or Enter) to finish, Esc to cancel. The result is a
// plain Polygon (64-step ring) so it works everywhere a polygon does,
// including Planet subscriptions which reject non-polygon geometries.
const DrawCircleMode = {
  onSetup() {
    const polygon = this.newFeature({
      type: 'Feature',
      properties: {
        isCircle: true
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[]]
      }
    })

    this.addFeature(polygon)
    this.clearSelectedFeatures()
    this.updateUIClasses({ mouse: 'add' })
    this.setActionableState({ trash: true })

    return { polygon, center: null }
  },

  updateCircle(state, e) {
    const point = [e.lngLat.lng, e.lngLat.lat]
    const radiusKm = distance(state.center, point)
    if (radiusKm <= 0) return

    const circleFeature = turfCircle(state.center, radiusKm, { steps: 64 })
    state.polygon.incomingCoords(circleFeature.geometry.coordinates)
    state.polygon.properties.center = state.center
    state.polygon.properties.radiusKm = radiusKm
  },

  onClick(state, e) {
    if (!state.center) {
      state.center = [e.lngLat.lng, e.lngLat.lat]
      return
    }
    this.updateCircle(state, e)
    this.changeMode('simple_select', { featureIds: [state.polygon.id] })
  },

  onTap(state, e) {
    this.onClick(state, e)
  },

  onMouseMove(state, e) {
    if (!state.center) return
    this.updateCircle(state, e)
  },

  onKeyUp(state, e) {
    if (e.keyCode === 27) { // Esc — cancel
      this.deleteFeature([state.polygon.id], { silent: true })
      this.changeMode('simple_select')
    } else if (e.keyCode === 13) { // Enter — finish
      this.changeMode('simple_select', { featureIds: [state.polygon.id] })
    }
  },

  onStop(state) {
    this.updateUIClasses({ mouse: 'none' })
    this.activateUIButton()

    if (this.getFeature(state.polygon.id) === undefined) return

    if (state.center && state.polygon.isValid()) {
      this.map.fire('draw.create', { features: [state.polygon.toGeoJSON()] })
    } else {
      this.deleteFeature([state.polygon.id], { silent: true })
      this.changeMode('simple_select', {}, { silent: true })
    }
  },

  onTrash(state) {
    this.deleteFeature([state.polygon.id], { silent: true })
    this.changeMode('simple_select')
  },

  toDisplayFeatures(state, geojson, display) {
    geojson.properties.active = geojson.properties.id === state.polygon.id ? 'true' : 'false'
    display(geojson)
  }
}

export default DrawCircleMode
